<template>
    <section class="sub_page_con wrap_1120 mypage_apply">
        <div class="search_wrap">
            <input type="text" v-model="state.searchText" @keyup.enter="getSearch" @keyup="getSearch" placeholder="검색어를 입력하세요." />
            <button class="search_btn icon_wrap" @click="getSearch"><img src="img/search_btn.png" alt="" /></button>
        </div>
        <div class="btn_wrap _default float_right _board_type" v-if="!state.isMobile">
            <button class="common_btn _gray" @click="isDelete">삭제</button>
        </div>

        <div class="checkbox_wrap" :style="!state.isMobile ? 'margin-top: 20px' : 'margin-top:10px; margin-bottom: 10px'">
            <label>
                <input
                    type="radio"
                    value="report"
                    v-model="state.selectedType"
                    @change="
                        getReportList();
                        state.checkedList = [];
                    "
                />
                <em></em>
                <span>시민제보</span>
            </label>
            <label>
                <input
                    type="radio"
                    value="participate"
                    v-model="state.selectedType"
                    @change="
                        getReportList();
                        state.checkedList = [];
                    "
                />
                <em></em>
                <span>시민참여</span>
            </label>
        </div>
        <div class="list_table con_board sub_page_con_view myContent">
            <ul v-if="state.selectedType === 'report'">
                <li class="thead_li">
                    <div class="tr_div con_tit">
                        <div class="tb_chk checkbox_wrap">
                            <label for="all">
                                <input id="all" type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                                <em></em>
                            </label>
                        </div>
                        <div class="tb_no D_only">번호</div>
                        <div class="tb_board">게시판</div>
                        <div class="tb_subject">제목</div>
                        <div class="tb_part">분류</div>
                        <div class="tb_date_hour">날짜</div>
                    </div>
                </li>

                <li class="tbody_li" v-for="(item, index) in state.list" :key="item.idx" v-if="state.list.length > 0">
                    <div class="tr_div con_tit" @click="toggle(index)">
                        <template v-if="!state.isMobile">
                            <div class="tb_chk checkbox_wrap" @click.stop>
                                <label :for="item.idx + ''" v-show="item.state !== 2">
                                    <input
                                        type="checkbox"
                                        v-model="state.checkedList"
                                        :id="item.idx + ''"
                                        :value="item.idx"
                                        @click.stop
                                        :disabled="item.state !== 1"
                                    />
                                    <em></em>
                                </label>
                            </div>
                            <div class="tb_no D_only">{{ (state.page - 1) * state.size + (index + 1) }}</div>
                            <div class="tb_board">{{ item.type === 1 ? "의심 업소" : "알선 광고" }}</div>
                            <div class="tb_subject" style="display: inline-flex">
                                <router-link :to="{ name: 'AdView', params: { id: item.idx } }" class="elips_1" style="width: auto !important">
                                    <u>
                                        {{ (item as types.ResReportVOForApi).title }}
                                    </u>
                                </router-link>
                                <span
                                    :class="[item.state === 1 ? 'ans_yet' : 'ans_complete']"
                                    v-text="item.state === 1 ? '접수중' : '접수완료'"
                                ></span>
                            </div>

                            <template v-if="item.type === 1">
                                <div class="tb_part">{{ (item as types.ResReportVOForApi).isSchool === 1 ? "학교주변" : "의심업소" }}</div>
                            </template>

                            <template v-else>
                                <div class="tb_part" v-if="(item as types.ResReportVOForApi).adType === 1">온라인 알선 광고</div>
                                <div class="tb_part" v-else-if="(item as types.ResReportVOForApi).adType === 2">지면 광고</div>
                                <div class="tb_part" v-else-if="(item as types.ResReportVOForApi).adType === 3">불법옥외광고물</div>
                                <div class="tb_part" v-else>기타</div>
                            </template>

                            <div class="tb_date_hour">
                                <span class="mo_th">날짜</span>
                                {{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}
                            </div>
                        </template>
                        <template v-else>
                            <div class="_flex _cate small_txt">
                                <div class="tb_board">{{ item.type === 1 ? "의심 업소" : "알선 광고" }}</div>
                                <span class="divider">｜</span>
                                <template v-if="item.type === 1">
                                    <div class="tb_part">{{ (item as types.ResReportVOForApi).isSchool === 1 ? "학교주변" : "의심업소" }}</div>
                                </template>
                                <template v-else>
                                    <div class="tb_part" v-if="(item as types.ResReportVOForApi).adType === 1">온라인 알선 광고</div>
                                    <div class="tb_part" v-else-if="(item as types.ResReportVOForApi).adType === 2">지면 광고</div>
                                    <div class="tb_part" v-else-if="(item as types.ResReportVOForApi).adType === 3">불법옥외광고물</div>
                                    <div class="tb_part" v-else>기타</div>
                                </template>
                            </div>
                            <div class="_flex _flex_100 _jc_sb">
                                <div class="tb_subject" style="display: inline-flex">
                                    <router-link :to="{ name: 'AdView', params: { id: item.idx } }" class="elips_1" style="width: auto !important">
                                        <u>
                                            {{ (item as types.ResReportVOForApi).shopName }}
                                        </u>
                                    </router-link>
                                    <span
                                        :class="[item.state === 1 ? 'ans_yet' : 'ans_complete']"
                                        v-text="item.state === 1 ? '접수중' : '접수완료'"
                                    ></span>
                                    <button class="m_option_btn icon_wrap only_768" @click="optionOpen(item)" v-if="item.state === 1">
                                        <img src="img/kebabIcon.png" class="" />
                                    </button>
                                    <div class="m_option_wrap" v-show="state.isShowBtn && state.list_idx === item.idx">
                                        <button type="button" class="_gray" @click="optionClose(item)">삭제</button>
                                    </div>
                                </div>
                                <div class="tb_date_hour">
                                    {{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}
                                </div>
                            </div>
                        </template>
                    </div>
                </li>
                <li v-else class="tbody_li no_data">
                    <div class="tr_div">
                        <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                    </div>
                </li>
            </ul>

            <ul v-else-if="state.selectedType === 'participate'">
                <li class="thead_li">
                    <div class="tr_div con_tit">
                        <div class="tb_chk checkbox_wrap">
                            <label for="all">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" id="all" />
                                <em></em>
                            </label>
                        </div>
                        <div class="tb_no D_only">번호</div>
                        <div class="tb_board">게시판</div>
                        <div class="tb_subject">제목</div>
                        <div class="tb_condition">조회수</div>
                        <div class="tb_date_hour">날짜</div>
                    </div>
                </li>

                <li class="tbody_li" v-for="(item, index) in state.list" :key="item.idx" v-if="state.list.length > 0">
                    <div class="tr_div con_tit" @click="toggle(index)">
                        <template v-if="!state.isMobile">
                            <div class="tb_chk checkbox_wrap" @click.stop>
                                <label :for="item.idx + ''">
                                    <input type="checkbox" v-model="state.checkedList" :id="item.idx + ''" :value="item.idx" @click.stop />
                                    <em></em>
                                </label>
                            </div>
                            <div class="tb_no D_only">{{ (state.page - 1) * state.size + (index + 1) }}</div>
                            <div class="tb_board">
                                <span v-if="item.type === 1">반성매매 시민활동</span>
                                <span v-else-if="item.type === 2">캠페인·이벤트</span>
                                <span v-else-if="item.type === 3">반성매매 활동 제안</span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="_flex _cate">
                                <div class="tb_chk checkbox_wrap" @click.stop>
                                    <label :for="item.idx + ''">
                                        <input type="checkbox" v-model="state.checkedList" :id="item.idx + ''" :value="item.idx" @click.stop />
                                        <em></em>
                                    </label>
                                </div>
                                <span class="mo_th">게시판</span>
                                <div class="tb_board" v-if="item.type === 1">반성매매 시민활동</div>
                                <div class="tb_board" v-else-if="item.type === 2">캠페인·이벤트</div>
                                <div class="tb_board" v-else-if="item.type === 3">반성매매 활동 제안</div>
                            </div>
                        </template>

                        <div class="tb_subject" style="display: inline-flex">
                            <router-link :to="{ name: 'SuggestView', params: { id: item.idx } }" class="elips_1" style="width: auto !important">
                                <u>
                                    {{ (item as types.ResBoardVOForApi).title }}
                                </u>
                            </router-link>
                        </div>
                        <div class="tb_condition D_only">
                            <span class="mo_th">조회수</span>
                            {{ (item as types.ResBoardVOForApi).viewCnt }}
                        </div>
                        <div class="tb_date_hour _cate">
                            <span class="mo_th">날짜</span>
                            {{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}
                        </div>
                    </div>
                </li>
                <li v-else class="tbody_li no_data">
                    <div class="tr_div">
                        <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                    </div>
                </li>
            </ul>
        </div>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
        <ModalDefault
            v-if="state.isShowModal"
            :type="state.modalTab"
            :title="state.modalTitle"
            :content="state.modalContent"
            @close="closeModal"
            @callback="callBackModal"
        ></ModalDefault>
    </section>
</template>
<script lang="ts" config>
    import {
        Header,
        Footer,
        router,
        ref,
        apiService,
        types,
        reactive,
        onMounted,
        CommonUtils,
        computed,
        ModalDefault,
        watch,
        PageBtn,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault, PageBtn },
        emits: ["view"],
        setup(props: any, { emit }: any) {
            const fnEvent = (idx: number) => {
                emit("view", idx);
            };

            const state = reactive({
                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                list: [] as Array<types.ResReportVOForApi | types.ResBoardVOForApi>,
                checkedList: [] as Array<number>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                checkAll: false as boolean,
                searchText: "" as string,

                selectedType: "report" as string,

                isMobile: false,
                isShowBtn: false,
                list_idx: 0 as number,
            });

            onMounted(() => {
                getReportList();

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => state.checkedList,
                (newVal) => {
                    if (state.list.filter((r) => r.state === 1).length !== 0)
                        state.checkAll = newVal.length === state.list.filter((r) => r.state === 1).length;
                    else state.checkAll = false;
                },
            );

            const getReportList = async () => {
                const param: types.ReqCommonPaging = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: state.searchText,
                };

                let res;
                if (state.selectedType === "report") {
                    res = await apiService.mypage.reportList(param); // 시민제보 API
                } else if (state.selectedType === "participate") {
                    res = await apiService.mypage.boardList(param); // 시민참여 API
                } else {
                    return;
                }

                if (res.returnCode === 0) {
                    state.list = res.list.data;

                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getReportList();
            };

            const getSearch = () => {
                state.page = 1;
                getReportList();
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    let res;
                    if (state.selectedType === "report") {
                        res = await apiService.mypage.reportMultiRemove(state.checkedList.join(","));
                    } else if (state.selectedType === "participate") {
                        res = await apiService.mypage.boardMultiRemove(state.checkedList.join(","));
                    } else {
                        return;
                    }

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getReportList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const openIndex = ref(null);
            const toggle = (index: any) => {
                openIndex.value = openIndex.value === index ? null : index;
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.filter((r) => r.state === 1).map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const optionOpen = (item: any) => {
                if (state.list_idx === item.idx) {
                    state.isShowBtn = false;
                    state.list_idx = 0;
                } else {
                    state.isShowBtn = true;
                    state.list_idx = item.idx;
                }
            };

            const optionClose = (item: any) => {
                state.checkedList = [item.idx];

                isDelete();
            };

            return {
                CommonUtils,
                router,
                fnEvent,
                state,
                handlePageChange,
                getSearch,
                isDelete,
                toggleAll,
                closeModal,
                callBackModal,
                toggle,
                getReportList,
                optionOpen,
                optionClose,
            };
        },
    };
</script>
<style scoped>
    .checkbox_wrap label {
        align-items: center;
    }
    .checkbox_wrap2 input[type="checkbox"] {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #fff;
        position: relative;
        vertical-align: sub;
        cursor: pointer;
        border: 1px solid #6d6d6d;
    }
    .checkbox_wrap2 em {
        display: none;
    }

    .tbody_li.no_data,
    .tbody_li.no_data .tr_div {
        background: transparent !important;
        cursor: default !important;
    }
    .tbody_li.no_data:hover,
    .tbody_li.no_data .tr_div:hover {
        background: transparent !important;
        cursor: default !important;
    }

    .checkbox_wrap input[type="checkbox"]:disabled + em {
        border-color: white;
    }
</style>
